import React from 'react';
import { connect } from 'react-redux';
import { DBTextAreaObjective, DBCheckBoxObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class ObservationPostureHeadPosition extends React.Component {

    render() {
        return (
            <div>
                <div className={styles.row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.mopno} flagText='Posture - Head Position' />
                    <label className={styles.label}>Head Position</label>
                </div>
                <div className={styles.row}>
                    <span className={styles.flag} />
                    <span className={styles.label} />
                    <DBCheckBoxObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOPOSHEADNORMAL'
                        className={styles.checkbox}
                        label='Normal'
                    />
                    <DBCheckBoxObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOPOSHEADSIDEBENTR'
                        className={styles.checkbox}
                        label='Sidebent R'
                    />

                </div>
                <div className={styles.row}>
                    <span className={styles.flag} />
                    <span className={styles.label} />
                    <DBCheckBoxObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOPOSHEADFORWARD'
                        className={styles.checkbox}
                        label='Forward'
                    />
                    <DBCheckBoxObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOPOSHEADSIDEBENTL'
                        className={styles.checkbox}
                        label='Sidebent L'
                    />
                </div>
                <div className={styles.row}>
                    <span className={styles.flag} />
                    <span className={styles.label} />
                    <DBCheckBoxObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOPOSHEADLATFLEX'
                        className={styles.checkbox}
                        label='Lateral Flexion'
                    />
                </div>
                <div className={styles.row}>
                    <span className={styles.flag} />
                    <span className={styles.label} />
                    <label className={styles.sublabel}>Comments:</label>
                </div>
                <div className={styles.row}>
                    <span className={styles.flag} />
                    <span className={styles.label} />
                    <DBTextAreaObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVEOBS'
                        entityKeyColumn='OONO'
                        entityKeyValue={this.props.oono}
                        field='OOPOSHEADTXT'
                        className={styles.textarea}
                    />
                </div>
            </div >
        );
    }
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let oono = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEOBS)
        .find(key => (state.entities.notes.PTOBJECTIVEOBS[key].OOEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEOBS[key].OONTNO === pk && noteType !== 1)));

    return {
        noteId: noteId,
        oono: oono,
        flagged: state.entities.notes.PTOBJECTIVEOBS[oono].OOPOSHEADNORMAL ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOPOSHEADSIDEBENTR ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOPOSHEADFORWARD ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOPOSHEADSIDEBENTL ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOPOSHEADLATFLEX ||
            state.entities.notes.PTOBJECTIVEOBS[oono].OOPOSHEADTXT
            ? true : false
    };
}

const connectedObservationPostureHeadPosition = connect(mapStateToProps)(ObservationPostureHeadPosition);
export { connectedObservationPostureHeadPosition as ObservationPostureHeadPosition };


